<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="product-detail container page-content">
                <div class="row">
                    <div class="col-12 d-md-none bg-white">
                        <ul class="breadcrumb"><li class="breadcrumb-item"></li><li class="breadcrumb-item active"><span>{{ parentCat }}</span></li></ul>
                    </div>
                    <div class="col-12 col-md-5 col-lg-6 product-detail__carousel">
                        <slot name="image-carousel"></slot>
                    </div>
                    <div class="col-12 col-md-7 col-lg-6 product-detail__product-data">
                        <div>
                            <!-- START SINGLEITEM_DETAILS SCROLL => v-stick-in-parent-->

                            <h1 class="product-detail__title">
                                {{ currentVariation | itemName }}
                            </h1>

                            <div class="row mt-2">
                                <div class="col-7">
                                    <item-availability class="product-detail__availability"></item-availability>
                                    <a class="text-muted small" href="/shop/versandkosten/">
                                        (Ausland abweichend)
                                    </a>
                                </div>
                                <div class="col-5">
                                    <span class="product-detail__id">
                                        <b>{{ $translate("Ceres::Template.singleItemNumber") }}:</b>
                                        {{ currentVariation.item.id }}
                                    </span>
                                </div>
                            </div>

                            <slot name="tag-list"></slot>

                            <hr>

                            <slot name="before-price"></slot>

                            <div class="product-detail__property-list" v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                <order-property-list></order-property-list>
                            </div>

                            <!--<graduated-prices></graduated-prices>-->

                            <item-price :show-net-prices="showNetPrices" :has-shipping-costs-category-id="hasShippingCostsCategoryId" :show-cross-price="isRecommendedPriceActive"></item-price>

                            <slot name="after-price"></slot>

                            <slot name="additional-content-after-vat"></slot>

                            <!-- Variation -->
                            <div class="product-detail__variation" v-if="attributes.length || Object.keys(units).length">
                                <variation-select></variation-select>
                            </div>
                            <!-- /Variation -->

                            <p class="product-detail__short-description"
                               v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                               v-html="currentVariation.texts.shortDescription">
                            </p>

                            <!-- Item Bundle -->
                            <div class="product-detail__bundle">
                                <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'" :bundle-type="currentVariation.variation.bundleType" :bundle-components="currentVariation.bundleComponents"></item-bundle>
                            </div>
                            <!-- /Item Bundle -->

                            <slot name="before-add-to-basket"></slot>

                            <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                {{ $translate("Ceres::Template.singleItemSetInfo") }}
                            </div>

                            <hr>

                            <div v-if="currentVariation.item.itemType != 'set'" class="product-detail__add-to-basket">
                                <add-to-basket
                                        class="product-detail__qty-basket"
                                        :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                        :use-large-scale="false"
                                        :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice"
                                    >
                                </add-to-basket>
                                <div v-if="isWishListEnabled" class="product-detail__wishlist">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>
                            </div>

                            <ul class="social-media share-icons list-inline">
                                <li>Teilen:</li>
                                <li class="single__social-item">
                                    <a href="http://www.facebook.com/sharer/sharer.php?u=https://www.tuning-fanatics.de/ersatzteile/beleuchtung-birne-lampe/lampen-und-leds/1-x-xenon-super-white-halogen-birne-lampe-6000k-hb4-e-pruefzeichen-tuev-frei/a-39423831/" data-toggle="tooltip" target="_blank" data-placement="bottom" title="" data-original-title="Wenn Du den Button anklickst öffnet sich ein neues Fenster, in dem Du dich mit deinen Daten bei Facebook einloggen kannst. Erst nach diesem aktiven Login wird eine direkte Verbindung zu Facebook hergestellt.">
                                        <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Screendesign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="xl-redesign-product-v2" transform="translate(-991.000000, -746.000000)" fill="#1A1A1D">
                                                    <g id="article" transform="translate(351.000000, 246.000000)">
                                                        <g id="art-data" transform="translate(552.000000, 0.000000)">
                                                            <g id="Share" transform="translate(2.496424, 496.194883)">
                                                                <g id="facebook" transform="translate(86.000000, 0.000000)">
                                                                    <path d="M15.3307282,17.1390369 L15.3307282,7.60249329 C15.3307282,6.02300325 14.0492551,4.7415302 12.4697651,4.7415302 L2.93322148,4.7415302 C1.35373144,4.7415302 0.0722583927,6.02300325 0.0722583927,7.60249329 L0.0722583927,17.1390369 C0.0722583927,18.718527 1.35373144,20 2.93322148,20 L8.33726287,20 L8.33726287,13.960189 L6.11206936,13.960189 L6.11206936,11.7349955 L8.33726287,11.7349955 L8.33726287,10.0859682 C8.33726287,8.11905607 9.55913252,7.04619491 11.3174328,7.04619491 C12.1518803,7.04619491 12.7876499,7.10579831 13.1055347,7.1356 L13.1055347,9.19191722 L11.7942599,9.20185112 C10.8406056,9.20185112 10.5624564,9.64887661 10.5624564,10.3144479 L10.5624564,11.7349955 L12.877055,11.7349955 L12.579038,13.960189 L10.5624564,13.960189 L10.5624564,20 L12.4697651,20 C14.0492551,20 15.3307282,18.718527 15.3307282,17.1390369 Z" id="fb-icon"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>Facebook</span>
                                    </a>
                                </li>
                                <li class="single__social-item">
                                    <a href="https://twitter.com/intent/tweet?text=1x XENON SUPER WHITE HALOGEN BIRNE LAMPE 6000K HB4 E-PRÜFZEICHEN Eintragungsfrei&amp;url=https://www.tuning-fanatics.de/ersatzteile/beleuchtung-birne-lampe/lampen-und-leds/1-x-xenon-super-white-halogen-birne-lampe-6000k-hb4-e-pruefzeichen-tuev-frei/a-39423831/&amp;via=TWITTER-HANDLE" target="_blank" data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Wenn Du den Button anklickst öffnet sich ein neues Fenster, in dem Du dich mit deinen Daten bei Twitter einloggen kannst. Erst nach diesem aktiven Login wird eine direkte Verbindung zu Twitter hergestellt.">
                                        <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Screendesign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="xl-redesign-product-v2" transform="translate(-1201.000000, -746.000000)" fill="#1A1A1D">
                                                    <g id="article" transform="translate(351.000000, 246.000000)">
                                                        <g id="art-data" transform="translate(552.000000, 0.000000)">
                                                            <g id="Share" transform="translate(2.496424, 496.194883)">
                                                                <g id="twitter" transform="translate(295.688182, 0.000000)">
                                                                    <path d="M13.2441036,9.35492904 C12.8721812,9.52096583 12.4703782,9.63386916 12.0386826,9.6936424 C12.4903026,9.42798354 12.7991264,9.03946327 12.9651632,8.52806995 C12.5334676,8.78044587 12.0884956,8.94980086 11.6302341,9.03613999 C11.2251043,8.59780286 10.7170394,8.37863758 10.106024,8.37863758 C9.52821593,8.37863758 9.03509406,8.58285978 8.62664355,8.99131028 C8.21819304,9.39976079 8.01397085,9.89288267 8.01397085,10.4706907 C8.01397085,10.6632934 8.03057428,10.8226863 8.06378163,10.9488743 C7.20703179,10.902384 6.40342577,10.6865394 5.65293947,10.301334 C4.90245317,9.91612867 4.26488145,9.40142233 3.74020518,8.75719958 C3.54760251,9.08927316 3.45130261,9.44126588 3.45130261,9.8131883 C3.45130261,10.5703161 3.75348504,11.1514361 4.35785896,11.5565659 C4.04570979,11.5499244 3.71364119,11.4635866 3.36164319,11.2975498 L3.36164319,11.3174741 C3.36164319,11.8155845 3.52767749,12.2588961 3.85975108,12.6474222 C4.19182466,13.0359483 4.60026904,13.276698 5.08509648,13.3696786 C4.8924938,13.4228104 4.72313881,13.4493759 4.57702643,13.4493759 C4.4906873,13.4493759 4.36118055,13.4360931 4.18850228,13.4095272 C4.32797319,13.8279399 4.5753643,14.1732913 4.93068303,14.4455916 C5.28600177,14.717892 5.68946512,14.8573608 6.14108519,14.8640023 C5.37067448,15.4617347 4.50397542,15.7605965 3.54096203,15.7605965 C3.36828377,15.7605965 3.20224946,15.7506344 3.04285414,15.73071 C4.02579195,16.3550083 5.09505286,16.6671528 6.25066893,16.6671528 C6.99451376,16.6671528 7.69185783,16.5492685 8.34272205,16.3134962 C8.99358628,16.077724 9.55146153,15.7622588 10.0163645,15.3670912 C10.4812676,14.9719237 10.8814102,14.5169897 11.2168046,14.0022756 C11.5521989,13.4875616 11.8012503,12.9496104 11.9639664,12.3884061 C12.1266824,11.8272017 12.2080392,11.2676661 12.2080392,10.7097825 C12.2080392,10.590236 12.2047186,10.5005775 12.1980771,10.4408042 C12.6164898,10.141938 12.9651618,9.77998323 13.2441036,9.35492904 Z M15.794416,7.42227044 L15.794416,16.9859419 C15.794416,17.776277 15.5138181,18.4520366 14.9526137,19.013241 C14.3914093,19.5744453 13.7156497,19.8550433 12.9253146,19.8550433 L3.36164319,19.8550433 C2.57130806,19.8550433 1.89554845,19.5744453 1.33434409,19.013241 C0.773139737,18.4520366 0.492541767,17.776277 0.492541767,16.9859419 L0.492541767,7.42227044 C0.492541767,6.63193531 0.773139737,5.9561757 1.33434409,5.39497135 C1.89554845,4.83376699 2.57130806,4.55316902 3.36164319,4.55316902 L12.9253146,4.55316902 C13.7156497,4.55316902 14.3914093,4.83376699 14.9526137,5.39497135 C15.5138181,5.9561757 15.794416,6.63193531 15.794416,7.42227044 Z" id="twitter-icon"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>Twitter</span>
                                    </a>
                                </li>
                            </ul>

                            <slot name="after-add-to-basket"></slot>
                            <slot name="additional-content-after-add-to-basket"></slot>
                        </div>
                    </div>

                    <div class="col-12 col-lg-10 mx-auto desc-container">
                        <!-- ITEM DESCRIPTION -->

                        <h2 class="text-center">{{ $translate("Ceres::Template.singleItemDescription") }}</h2>
                        <div class="my-4" v-html="currentVariation.texts.description"></div>
                    </div>

                </div>
                <div class="last-seen-container">
                    <slot name="item-list-container"></slot>
                    <slot name="feedback-container"></slot>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    computed:
    {
        parentCat(){
            return $(".dia-header .breadcrumbs .breadcrumb-item:nth-last-child(2)").text();
        },

        itemConfig()
        {
            return App.config.item.itemData;
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
        this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
            itemId:             this.itemId,
            attributes:         this.attributesData,
            variations:         this.variations,
            initialVariationId: this.currentVariation.variation.id,
            isPleaseSelectOption: this.initPleaseSelectOption,
            afterKey:           this.afterKey
        });
    },

    mounted(){
        this.$nextTick(() =>
        {
            $("[data-toggle=\"tooltip\"]").tooltip();
        });
    },

    methods:
    {
        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        }
    }
}
</script>
